import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveFilter as _resolveFilter, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  key: 0,
  style: {
    "width": "100%",
    "padding-top": "20vh",
    "text-align": "center"
  }
};
const _hoisted_2 = {
  key: 0
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_spinner = _resolveComponent("b-spinner");
  const _component_BillingList = _resolveComponent("BillingList");
  const _component_b_table = _resolveComponent("b-table");
  const _component_b_col = _resolveComponent("b-col");
  const _component_b_row = _resolveComponent("b-row");
  const _component_b_card_text = _resolveComponent("b-card-text");
  const _component_b_card = _resolveComponent("b-card");
  const _component_b_container = _resolveComponent("b-container");
  const _filter_currency = _resolveFilter("currency");
  return _openBlock(), _createBlock(_component_b_container, {
    fluid: "",
    role: "region",
    "aria-label": "billing"
  }, {
    default: _withCtx(() => [_ctx.loading ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_b_spinner, {
      variant: "success",
      style: {
        "width": "3rem",
        "height": "3rem"
      }
    })])) : (_openBlock(), _createBlock(_component_b_row, {
      key: 1
    }, {
      default: _withCtx(() => [_createVNode(_component_b_col, {
        cols: "12"
      }, {
        default: _withCtx(() => [_createVNode(_component_b_card, {
          class: "mb-5"
        }, {
          default: _withCtx(() => [_createVNode(_component_b_card_text, null, {
            default: _withCtx(() => [!_ctx.loading ? (_openBlock(), _createBlock(_component_BillingList, {
              key: 0,
              records: _ctx.billing,
              address: _ctx.address,
              states: _ctx.states,
              countries: _ctx.countries
            }, null, 8, ["records", "address", "states", "countries"])) : _createCommentVNode("", true), _ctx.transactions && _ctx.transactions.length > 0 ? (_openBlock(), _createBlock(_component_b_row, {
              key: 1
            }, {
              default: _withCtx(() => [_createVNode(_component_b_col, {
                cols: "12"
              }, {
                default: _withCtx(() => [_cache[0] || (_cache[0] = _createElementVNode("hr", null, null, -1)), _cache[1] || (_cache[1] = _createElementVNode("h4", null, "Transaction History", -1)), _createVNode(_component_b_table, {
                  items: _ctx.transactions,
                  fields: _ctx.transactionFields,
                  striped: "",
                  hover: ""
                }, {
                  "cell(info)": _withCtx(data => [data.item.snapshot && data.item.snapshot.billing && data.item.snapshot.billing.billingtype_id ? (_openBlock(), _createElementBlock("span", _hoisted_2, [_withDirectives(_createElementVNode("span", null, [_createTextVNode(_toDisplayString(data.item.snapshot.billing.creditcardtype) + " ", 1), _withDirectives(_createElementVNode("span", null, "Ending in " + _toDisplayString(("0000" + data.item.snapshot.billing.number).slice(-4)), 513), [[_vShow, data.item.snapshot.billing.number]])], 512), [[_vShow, data.item.snapshot.billing.billingtype_id == 1]]), _withDirectives(_createElementVNode("span", null, _toDisplayString(data.item.snapshot.billing.billingtype && data.item.snapshot.billing.billingtype.name), 513), [[_vShow, data.item.snapshot.billing.billingtype_id != 1]])])) : _createCommentVNode("", true)]),
                  "cell(amount)": _withCtx(data => [_withDirectives(_createElementVNode("span", null, "(" + _toDisplayString(_filter_currency(data.item.debit)) + ")", 513), [[_vShow, data.item.debit > 0]]), _withDirectives(_createElementVNode("span", null, _toDisplayString(_filter_currency(data.item.credit)), 513), [[_vShow, data.item.credit > 0]])]),
                  _: 1
                }, 8, ["items", "fields"])], undefined, true),
                _: 1
              })], undefined, true),
              _: 1
            })) : _createCommentVNode("", true)], undefined, true),
            _: 1
          })], undefined, true),
          _: 1
        })], undefined, true),
        _: 1
      })], undefined, true),
      _: 1
    }))], undefined, true),
    _: 1
  });
}